import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PosPrintDocumentsModalService } from 'src/app/@core/services/pos-print-documents-modal.service';
import { DateUtils } from 'src/app/@core/utils/date-utils';
import { ColumnTable } from 'src/app/models/column-table';
import { Customer } from 'src/app/models/customer';
import { Loan } from 'src/app/models/loan';
import { Paging } from 'src/app/models/page';
import { ContractReturnResponseCompleteModel } from 'src/app/models/response/contract-return-response-complete-model';
import { CustomerService } from 'src/app/services/customer.service';
import { LoanService } from 'src/app/services/loan.service';

@Component({
  selector: 'app-stand-alone-return-contract-detail',
  templateUrl: './stand-alone-return-contract-detail.component.html',
  styleUrls: ['./stand-alone-return-contract-detail.component.sass'],
})
export class StandAloneReturnContractDetailComponent implements OnInit {
  loan: Loan = new Loan();
  customerInformation = '';
  createdDate: string = "";
  loans: Paging<Array<Loan>> = new Paging([]);
  returnContractResponse: ContractReturnResponseCompleteModel =
    new ContractReturnResponseCompleteModel();
  customer: Customer = new Customer();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loanService: LoanService,
    private printModalService: PosPrintDocumentsModalService,
    private readonly customerService: CustomerService,
    private readonly datePipe: DatePipe
  ) {
  }

  async ngOnInit(): Promise<void> {
    const contractNumber = this.route.snapshot.params.contractNumber;
    this.loan = (
      await this.loanService
        .getLoansByFilters({
          page: 0,
          pageSize: 100,
          value: { contractNumber },
        })
        .toPromise()
    ).response[0];
    this.loans = new Paging([this.loan]);
    this.customer = await this.customerService.readCustomerByCode(this.loan.customerCode).toPromise();
    this.customerInformation = `[${this.customer.code}] - [${this.customer.fullName}]`;
    this.createdDate = this.datePipe.transform(DateUtils.getDateFromStringWithoutTime2(this.loan.creationDate), "longDate") || "";
  }

  async print(): Promise<void> {
    await this.printModalService.showPrintContractReturnDocuments(this.returnContractResponse);
  }

  getLoanHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable('contractNumber', 'Número de Contrato'),
      new ColumnTable('amount', 'Total', { type: 'currency' }),
      new ColumnTable('creationDate', 'Fecha de creación', {
        type: 'date',
        dateType: 'dateFromString',
      }),
      new ColumnTable('lastPaymentDate', 'Fecha última cuota pagada', {
        type: 'date',
      }),
    ];
  }
}
